import Aggrid from './Aggrid'

export default Aggrid
